import BirthdayInput from './BirthdayInput'
import Button from './Button'
import DatePickerInput from './DatePickerInput'
import DropZone from './DropZone'
import FileUploadInput from './FileUploadInput'
import Form from './Form'
import Loading from './Loading'
import LocationInput from './LocationInput'
import SelectInput from './SelectInput'
import TextAreaInput from './TextAreaInput'
import TextInput from './TextInput'
import TextEditor from './TextEditor'
import RadioButton from './RadioButton'
import TimePicker from './TimePicker'
import Loader from './Loader'
import Checkbox from './Checkbox'
import UploadAvatar from './UploadAvatar'
export * from './StyledComponents'

export {
  BirthdayInput,
  Button,
  DatePickerInput,
  DropZone,
  FileUploadInput,
  Form,
  Loading,
  LocationInput,
  SelectInput,
  TextAreaInput,
  TextInput,
  TextEditor,
  RadioButton,
  TimePicker,
  Checkbox,
  Loader,
  UploadAvatar
}



// WEBPACK FOOTER //
// src/components/UI/index.js